import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarClock } from "lucide-react";
import NeonChomp from "../effects/NeonChomp";
import Reveal, { SplitTitle } from "../ui/Reveal";
import { GHOST_BUTTON_DARK } from "../ui/styles";
import useLang from "../../hooks/useLang";

// Closing call to action: the neon chomper eats its way through the challenges.
const ChallengeCtaSection = () => {
  const { t } = useLang();

  return (
    <section className="relative overflow-hidden bg-ink text-white isolate">
      <div
        className="pointer-events-none absolute -z-10 top-1/2 end-[-10%] h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-amber-400/10 blur-[120px]"
        aria-hidden="true"
      />
      <div className="container-site py-20 sm:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-6">
          <SplitTitle text={t("cta.title")} className="h-section" />
          <p className="lead text-white/75 mt-5">{t("cta.description")}</p>
          <div className="flex flex-wrap items-center gap-4 mt-9">
            <Link to="/contact" className="btn-rose group">
              {t("cta.button")} <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
            <Link
              to="/contact?mode=call"
              className={GHOST_BUTTON_DARK}
            >
              <CalendarClock size={16} /> {t("cta.bookCall")}
            </Link>
          </div>
        </Reveal>
        <NeonChomp className="lg:col-span-6" />
      </div>
    </section>
  );
};

export default ChallengeCtaSection;
